module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "spw-chevron-up-light-blue.1b9a72b4.svg";